<div class="pme-container" [hidden]="hideIdentification">
    <div class="pme-row display-utils-col display-utils-gt-sm-row display-utils-gap-0 display-utils-gt-sm-gap-60">
        <div class="pme-col display-utils-gt-sm-flex-50">
            <main>
                <h1 class="mat-headline">Identificação</h1>

                <form [formGroup]="formControlService.identificationForm" (ngSubmit)="this.onSubmit()">
                    <mat-tab-group mat-stretch-tabs animationDuration="0ms" [(selectedIndex)]="this.selectedIndex" (selectedIndexChange)="storeIdentificationIndex(selectedIndex)">
                        <mat-tab label="Cadastrar" *ngIf="!this.hideRegister">
                            <ng-template matTabContent>
                                <fieldset *ngIf="!this.hideFields.legalName || !this.hideFields.cpf || !this.hideFields.cnpj || !this.hideFields.name || !this.hideFields.birthDate || !this.hideFields.email || !this.hideFields.cellphone">
                                    <legend class="mat-subheading-1">Dados pessoais</legend>

                                    <mat-form-field appearance="outline" *ngIf="!this.hideFields.legalName">
                                        <mat-label>Razão social</mat-label>
                                        <input matInput type="text" id="legalName" name="legalName" required autocomplete="legalName" #name [(ngModel)]="customer.companyLegalName" formControlName="legalName">
                                        <mat-error>{{formControlService.getIdentificationErrors().legalName}}</mat-error>
                                    </mat-form-field>

                                    <div class="display-utils-row-wrap display-utils-gt-xs-gap-24" *ngIf="!this.hideFields.cnpj && !this.hideFields.cpf">
                                        <div class="display-utils-flex-100 display-utils-gt-xs-flex-half-gap-24">
                                            <mat-form-field appearance="outline">
                                                <mat-label>CNPJ da empresa</mat-label>
                                                <input matInput type="tel" inputmode="numeric" id="cnpj" name="cnpj" required [readOnly]="true" placeholder="00.000.000/0000-00" #cnpj formControlName="cnpj" [(ngModel)]="customer.cnpj" [mask]="masks.cnpj">
                                                <mat-error>{{formControlService.getIdentificationErrors().cnpj}}</mat-error>
                                            </mat-form-field>
                                        </div>

                                        <div class="display-utils-flex-100 display-utils-gt-xs-flex-half-gap-24">
                                            <mat-form-field appearance="outline">
                                                <mat-label>CPF</mat-label>
                                                <input matInput type="tel" inputmode="numeric" id="cpf" name="cpf" placeholder="000.000.000-00" required #cpf formControlName="cpf" [(ngModel)]="customer.cpf" [mask]="masks.cpf">
                                                <mat-error>{{formControlService.getIdentificationErrors().cpf}}</mat-error>
                                            </mat-form-field>
                                        </div>
                                    </div>

                                    <mat-form-field appearance="outline" *ngIf="!this.hideFields.name">
                                        <mat-label>Nome completo</mat-label>
                                        <input matInput type="text" id="name" name="name" required autocomplete="name" #name [(ngModel)]="customer.name" formControlName="name">
                                        <mat-error>{{formControlService.getIdentificationErrors().name}}</mat-error>
                                    </mat-form-field>

                                    <div class="display-utils-row-wrap display-utils-gt-xs-gap-24" *ngIf="!this.hideFields.birthDate && !this.hideFields.cellphone">
                                        <div class="display-utils-flex-100 display-utils-gt-xs-flex-half-gap-24">
                                            <mat-form-field appearance="outline">
                                                <mat-label>Data de nascimento</mat-label>
                                                <input matInput type="text" id="birthDate" name="birthDate" placeholder="DD/MM/AAAA" autocomplete="bday" #birthDate [mask]="masks.date" [(ngModel)]="customer.birthDate" formControlName="birthDate" required>
                                                <mat-error>{{formControlService.getIdentificationErrors().birthDate}}</mat-error>
                                            </mat-form-field>
                                        </div>

                                        <div class="display-utils-flex-100 display-utils-gt-xs-flex-half-gap-24">
                                            <mat-form-field appearance="outline">
                                                <mat-label>Telefone celular</mat-label>
                                                <input matInput type="tel" inputmode="numeric" name="mobile" id="cellphone" required placeholder="(00) 90000-0000" autocomplete="tel" #cellphone [(ngModel)]="customer.cellphone" [mask]="masks.mobilePhoneNumber" formControlName="cellphone">
                                                <mat-error>{{formControlService.getIdentificationErrors().cellphone}}</mat-error>
                                            </mat-form-field>
                                        </div>
                                    </div>

                                    <mat-form-field appearance="outline" *ngIf="!this.hideFields.email">
                                        <mat-label>E-mail</mat-label>
                                        <input matInput type="email" id="email" name="email" required autocomplete="email" maxlength="60" #email [(ngModel)]="customer.email" formControlName="email">
                                        <mat-error>{{formControlService.getIdentificationErrors().email}}</mat-error>
                                    </mat-form-field>
                                </fieldset>

                                <fieldset *ngIf="!this.hideFields.all">
                                    <legend class="mat-subheading-1">Dados de cobrança</legend>

                                    <div class="display-utils-row display-utils-gap-8">
                                        <div class="display-utils-flex-50">
                                            <mat-form-field appearance="outline">
                                                <mat-label>CEP</mat-label>
                                                <input matInput type="text" pattern="[0-9]*" inputmode="numeric" name="zipcode" id="zipcode" required placeholder="00000-000" autocomplete="postal-code" #zipcode formControlName="zipcode" [(ngModel)]="customer.zipcode" [mask]="masks.cep">
                                                <mat-error>{{formControlService.getIdentificationErrors().zipcode}}</mat-error>
                                            </mat-form-field>
                                        </div>

                                        <div class="display-utils-flex-50">
                                            <a class="pme-link-correios" href="http://www.buscacep.correios.com.br/sistemas/buscacep/buscaCepEndereco.cfm" target="_blank" rel="noreferrer">Não sei meu CEP</a>
                                        </div>
                                    </div>

                                    <div class="display-utils-row display-utils-gap-8 display-utils-gt-xs-gap-24">
                                        <div class="display-utils-flex-70">
                                            <mat-form-field appearance="outline">
                                                <mat-label>Endereço</mat-label>
                                                <input matInput type="text" name="address" id="address" #address name="address" required autocomplete="street-address" maxlength="60" formControlName="street" [(ngModel)]="customer.street">
                                                <mat-error>{{formControlService.getIdentificationErrors().street}}</mat-error>
                                            </mat-form-field>
                                        </div>

                                        <div class="display-utils-flex-30">
                                            <mat-form-field appearance="outline">
                                                <mat-label>Número</mat-label>
                                                <input matInput type="text" id="number" required maxlength="10" #number [(ngModel)]="customer.number" formControlName="number">
                                                <mat-error>{{formControlService.getIdentificationErrors().number}}</mat-error>
                                            </mat-form-field>
                                        </div>
                                    </div>

                                    <div class="display-utils-row-wrap display-utils-gt-xs-gap-24">
                                        <div class="display-utils-flex-100 display-utils-gt-xs-flex-half-gap-24">
                                            <mat-form-field appearance="outline">
                                                <mat-label>Complemento (opcional)</mat-label>
                                                <input matInput type="text" id="complement" name="complement" autocomplete="address-line1" maxlength="20" #complement [(ngModel)]="customer.complement" formControlName="complement">
                                                <mat-error>{{formControlService.getIdentificationErrors().complement}}</mat-error>
                                            </mat-form-field>
                                        </div>

                                        <div class="display-utils-flex-100 display-utils-gt-xs-flex-half-gap-24">
                                            <mat-form-field appearance="outline">
                                                <mat-label>Bairro</mat-label>
                                                <input matInput type="text" id="quarter" name="quarter" required autocomplete="address-level3" maxlength="30" #quarter [(ngModel)]="customer.quarter" formControlName="quarter">
                                                <mat-error>{{formControlService.getIdentificationErrors().quarter}}</mat-error>
                                            </mat-form-field>
                                        </div>
                                    </div>

                                    <div class="display-utils-row display-utils-gap-8 display-utils-gt-xs-gap-24">
                                        <div class="display-utils-flex-50">
                                            <mat-form-field appearance="outline">
                                                <mat-label>Cidade</mat-label>
                                                <input matInput type="text" id="city" name="city" required autocomplete="address-level2" maxlength="35" #city formControlName="city" [(ngModel)]="customer.city">
                                                <mat-error>{{formControlService.getIdentificationErrors().city}}</mat-error>
                                            </mat-form-field>
                                        </div>

                                        <div class="display-utils-flex-50">
                                            <mat-form-field appearance="outline">
                                                <mat-label>Estado</mat-label>
                                                <select matNativeControl id="state" name="state" required autocomplete="address-level1" #state [(ngModel)]="customer.state" formControlName="state">
                          <option *ngFor="let state of states" [value]="state">
                            {{state}}
                          </option>
                        </select>
                                                <mat-error>{{formControlService.getIdentificationErrors().state}}</mat-error>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </fieldset>
                            </ng-template>
                        </mat-tab>

                        <mat-tab label="Acesse sua conta" *ngIf="!this.isLogged">
                            <ng-template matTabContent>
                                <mat-form-field class="mat-form-email" appearance="outline" *ngIf="!this.hideFields.email">
                                    <mat-label>E-mail</mat-label>
                                    <input matInput type="email" id="email" name="email" required autocomplete="email" maxlength="60" #email [(ngModel)]="customer.email" formControlName="email">
                                    <mat-error>{{formControlService.getIdentificationErrors().email}}</mat-error>
                                </mat-form-field>
                            </ng-template>

                        </mat-tab>


                    </mat-tab-group>


                    <pme-alert type="warn" title="Erro" *ngIf="this.onSubmitIdentificationErrors && this.onSubmitIdentificationErrors.length">
                        <div *ngFor="let error of this.onSubmitIdentificationErrors" [innerHTML]="error"></div>
                    </pme-alert>

                    <div class="pme-fixed-button display-utils-row display-utils-center-center display-utils-gap-20">
                        <a *ngIf="this.showBackButton" href="{{this.redirectUrl}}">Voltar</a>
                        <button mat-flat-button color="primary" type="submit" class="pme-btn-lg" [disabled]="submitting || !this.formControlService.identificationForm.valid">
                            <div class="display-utils-row display-utils-center-center display-utils-gap-29">
                                <mat-spinner *ngIf="submitting" diameter="20" aria-label="Carregando"></mat-spinner>
                                <div>{{this.submitButtonName}}</div>
                            </div>
                        </button>
                    </div>

                    <div class="pme-register mat-subheading-1 display-utils-center-center" *ngIf="!this.isLogged">   
                        Novo por aqui? &nbsp;<a (click)="openCadastroDeslogado()" > <b>Cadastre-se agora!</b></a>
                    </div>
                </form>
            </main>
        </div>

        <div class="pme-col display-utils-gt-sm-flex-50">
            <aside>
                <!-- Exemplo de visualização do produto selecionado -->
                <div *ngIf="this.cartComponent && this.cartComponent.cart">
                    <pme-product-choice [cardTitle]="this.cardTitle" [changeText]="this.changeProductText" [changeLink]="this.changeProductLink" [productName]='this.cartComponent.cart.product.name' [totalValue]="this.cartComponent.cart.baseValue.toString()" [description]="this.cartComponent.cart.product.description"
                        [extraBalanceCoupon]="this.cartComponent.cart.extraBalanceCoupon">
                    </pme-product-choice>
                </div>
                <div class="pme-aside-warning display-utils-row display-utils-between-center display-utils-gap-16" *ngIf="this.classificationIdentifier && this.classificationIdentifier === 'consulta-e-recuperacao-de-dividas'">
                    <div>
                        <p *ngIf="this.cartComponent && this.cartComponent.cart && this.cartComponent.cart.extraBalanceCoupon ; else noExtraBalance">Créditos do pacote expiram em 6 meses. Créditos do bônus válidos até {{this.cartComponent.cart.extraBalanceCoupon.formatedExpirationDate}}.</p>
                        <ng-template #noExtraBalance>
                            <p>Créditos do pacote expiram em 6 meses.</p>
                        </ng-template>
                    </div>
                </div>
                <pme-cart (allowAutomaticRechargeChange)="this.onAutomaticRechargeChange($event)"></pme-cart>
            </aside>
        </div>
    </div>
</div>

<!--
<pme-bottom-sheet-cart class="display-utils-hide-gt-sm"
  [buttonRouterLink]="buttonRouterLink"
  [buttonName]="buttonName"
  [step]="this.step"
  [submitting]="this.submitting"
  (identificationSubmit)="onSubmit()">
</pme-bottom-sheet-cart>
-->
